import { AusActions } from "@aus/Store/AusState";
import HeaderState from "@aus/Store/Pages/Header/HeaderState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<HeaderState, DispatchProp<AusActions>>;

export const UpdateState: HandlerType = props => {
    props.dispatch({
        type: "Pages/Header/UpdateHeaderState",
        parameter: props.parameter,
    });
};

export const chain = [UpdateState];

const updateHeaderState = createHandlerChainRunner(chain, "UpdateHeaderState");
export default updateHeaderState;
